import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';

// import hooks
import useOnClickOutside from '@/hooks/useOnClickOutside';

const SortDesktopFilter = ({ sorts, sortByLabel, onApplySort }) => {
  const wrapperRef = useRef();
  const [isOpen, setIsOpen] = useState(false);
  useOnClickOutside(wrapperRef, () => setIsOpen(false));

  if (!sorts) return null;
  const selectedSort = sorts.find(sort => sort.selected);

  return (
    <section
      ref={wrapperRef}
      className={`ken-plp__filters__desktop-bar__sort ${
        isOpen ? '--open' : ''
      }`}
    >
      <button type='button' onClick={() => setIsOpen(!isOpen)}>
        {sortByLabel}:<span>{selectedSort?.name}</span>
        <i className='ken-icon ken-icon--down-black' />
      </button>
      <section
        className={`ken-plp__filters__desktop-bar__sort__overlay ${
          isOpen ? '--open' : ''
        }`}
      >
        <section className='ken-plp__filters__desktop-bar__sort__overlay__content'>
          {sorts.map(sort => (
            <button
              key={sort.code}
              type='button'
              className={`${sort.selected ? '--selected' : ''}`}
              onClick={() => !sort.selected && onApplySort(sort.code)}
            >
              <span>{sort.name}</span>
            </button>
          ))}
        </section>
      </section>
    </section>
  );
};

SortDesktopFilter.propTypes = {
  sorts: PropTypes.arrayOf(PropTypes.shape()),
  sortByLabel: PropTypes.string.isRequired,
  onApplySort: PropTypes.func,
};

SortDesktopFilter.defaultProps = {
  sorts: null,
  onApplySort: null,
};

export default SortDesktopFilter;

// MOUSE OVER EVENT
//  remove useOnClickOutside hook
//  ken-plp__filters__desktop-bar__sort
//    onMouseOut={() => setIsOpen(false)}
//    onBlur={() => setIsOpen(false)}
//    onMouseOver={() => setIsOpen(true)}
//    onFocus={() => setIsOpen(true)}
//  button
//    no events
